import { db } from '../../firebase';
import { doc, getDoc } from "firebase/firestore";

export const getUser = async (id) => {
    console.log('Fetching user');

    try {
        const q = doc(db, "users", id);

        const querySnapshot = await getDoc(q);
        if (!querySnapshot.exists()) {
            throw new Error('User not found');
        }

        const userDocData = {
            id: querySnapshot.id,
            ...querySnapshot.data(),
        };
        console.log('userDoc: ', userDocData);
        return {
            userDocData, loaded: false
        }
    } catch (e) {
        console.log(e);
        throw e;
    }

};
